import { render, staticRenderFns } from "./HSCodes.vue?vue&type=template&id=36994c82&"
import script from "./HSCodes.vue?vue&type=script&lang=js&"
export * from "./HSCodes.vue?vue&type=script&lang=js&"
import style0 from "./HSCodes.vue?vue&type=style&index=0&id=36994c82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports